var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "contacts-section" },
    [
      _c("header-inner"),
      _c(
        "wrapper",
        {
          staticClass: " page--bottom",
          attrs: { "line-borders": false, "line-center": true }
        },
        [
          _c("div", { staticClass: "main-title" }, [_c("h1", [_vm._v("UI")])]),
          _c("div", { staticClass: "main-title" }, [
            _c("h2", { staticClass: "text-center" }, [_vm._v("Иконки SVG")])
          ]),
          _c("p", [_vm._v('Используется: class="icons_svg icon_1"')]),
          _c("ul", { staticClass: "ul__icons" }, [
            _c("li", { staticClass: "icons_svg icon_1" }, [
              _vm._v("icon_1 измерение_аудитории")
            ]),
            _c("li", { staticClass: "icons_svg icon_2" }, [
              _vm._v("icon_2 конверсия")
            ]),
            _c("li", { staticClass: "icons_svg icon_3" }, [
              _vm._v("icon_3 онлаи?н_продажа")
            ]),
            _c("li", { staticClass: "icons_svg icon_4" }, [
              _vm._v("icon_4 планирование рк")
            ]),
            _c("li", { staticClass: "icons_svg icon_5" }, [
              _vm._v("icon_5 прикрепить фаил")
            ]),
            _c("li", { staticClass: "icons_svg icon_6" }, [
              _vm._v("icon_6 ретаргетинг")
            ]),
            _c("li", { staticClass: "icons_svg icon_7" }, [
              _vm._v("icon_7 скачать")
            ]),
            _c("li", { staticClass: "icons_svg icon_8" }, [
              _vm._v("icon_8 таргетинг")
            ]),
            _c("li", { staticClass: "icons_svg icon_9" }, [
              _vm._v("icon_9 bb")
            ]),
            _c("li", { staticClass: "icons_svg icon_10" }, [
              _vm._v("icon_10 bb")
            ]),
            _c("li", { staticClass: "icons_svg icon_11" }, [
              _vm._v("icon_11 citybord")
            ]),
            _c("li", { staticClass: "icons_svg icon_12" }, [
              _vm._v("icon_12 citybord")
            ]),
            _c("li", { staticClass: "icons_svg icon_13" }, [
              _vm._v("icon_13 cityformat")
            ]),
            _c("li", { staticClass: "icons_svg icon_14" }, [
              _vm._v("icon_14 cityformat")
            ]),
            _c("li", { staticClass: "icons_svg icon_15" }, [
              _vm._v("icon_15 cityformat")
            ]),
            _c("li", { staticClass: "icons_svg icon_16" }, [
              _vm._v("icon_16 dbb")
            ]),
            _c("li", { staticClass: "icons_svg icon_17" }, [
              _vm._v("icon_17 dbb")
            ]),
            _c("li", { staticClass: "icons_svg icon_18" }, [
              _vm._v("icon_18 dbb")
            ]),
            _c("li", { staticClass: "icons_svg icon_19" }, [
              _vm._v("icon_19 dbb")
            ]),
            _c("li", { staticClass: "icons_svg icon_20" }, [
              _vm._v("icon_20 dbb")
            ]),
            _c("li", { staticClass: "icons_svg icon_21" }, [
              _vm._v("icon_21 dss")
            ]),
            _c("li", { staticClass: "icons_svg icon_22" }, [
              _vm._v("icon_22 dss")
            ]),
            _c("li", { staticClass: "icons_svg icon_23" }, [
              _vm._v("icon_23 pillar")
            ]),
            _c("li", { staticClass: "icons_svg icon_24" }, [
              _vm._v("icon_24 pillar")
            ]),
            _c("li", { staticClass: "icons_svg icon_25" }, [
              _vm._v("icon_25 pillar")
            ]),
            _c("li", { staticClass: "icons_svg icon_26" }, [
              _vm._v("icon_26 pillar")
            ]),
            _c("li", { staticClass: "icons_svg icon_27" }, [
              _vm._v("icon_27 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_28" }, [
              _vm._v("icon_28 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_29" }, [
              _vm._v("icon_29 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_30" }, [
              _vm._v("icon_30 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_31" }, [
              _vm._v("icon_31 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_32" }, [
              _vm._v("icon_32 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_33" }, [
              _vm._v("icon_33 ss")
            ]),
            _c("li", { staticClass: "icons_svg icon_51" }, [_vm._v("icon_51")]),
            _c("li", { staticClass: "icons_svg icon_52" }, [_vm._v("icon_52")]),
            _c("li", { staticClass: "icons_svg icon_53" }, [_vm._v("icon_53")]),
            _c("li", { staticClass: "icons_svg icon_54" }, [_vm._v("icon_54")]),
            _c("li", { staticClass: "icons_svg icon_55" }, [_vm._v("icon_55")]),
            _c("li", { staticClass: "icons_svg icon_56" }, [_vm._v("icon_56")]),
            _c("li", { staticClass: "icons_svg icon_57" }, [_vm._v("icon_57")]),
            _c("li", { staticClass: "icons_svg icon_58" }, [_vm._v("icon_58")]),
            _c("li", { staticClass: "icons_svg icon_59" }, [_vm._v("icon_59")]),
            _c("li", { staticClass: "icons_svg icon_60" }, [_vm._v("icon_60")]),
            _c("li", { staticClass: "icons_svg icon_61" }, [_vm._v("icon_61")]),
            _c("li", { staticClass: "icons_svg icon_62" }, [_vm._v("icon_62")]),
            _c("li", { staticClass: "icons_svg icon_63" }, [_vm._v("icon_63")]),
            _c("li", { staticClass: "icons_svg icon_64" }, [_vm._v("icon_64")]),
            _c("li", { staticClass: "icons_svg icon_65" }, [_vm._v("icon_65")]),
            _c("li", { staticClass: "icons_svg icon_66" }, [_vm._v("icon_66")]),
            _c("li", { staticClass: "icons_svg icon_67" }, [_vm._v("icon_67")]),
            _c("li", { staticClass: "icons_svg icon_68" }, [_vm._v("icon_68")]),
            _c("li", { staticClass: "icons_svg icon_69" }, [_vm._v("icon_69")]),
            _c("li", { staticClass: "icons_svg icon_70" }, [_vm._v("icon_70")]),
            _c("li", { staticClass: "icons_svg icon_71" }, [_vm._v("icon_71")]),
            _c("li", { staticClass: "icons_svg icon_72" }, [_vm._v("icon_72")]),
            _c("li", { staticClass: "icons_svg icon_73" }, [_vm._v("icon_73")]),
            _c("li", { staticClass: "icons_svg icon_74" }, [_vm._v("icon_74")])
          ]),
          _c("div", { staticClass: "main-title" }, [
            _c("h2", { staticClass: "text-center" }, [_vm._v("Иконки PNG")])
          ]),
          _c("p", [_vm._v('Используется: class="icons_png icon_1"')]),
          _c("ul", { staticClass: "ul__icons" }, [
            _c("li", { staticClass: "icons_png icon_1" }, [_vm._v("icon_1")]),
            _c("li", { staticClass: "icons_png icon_2" }, [_vm._v("icon_2")]),
            _c("li", { staticClass: "icons_png icon_3" }, [_vm._v("icon_3")]),
            _c("li", { staticClass: "icons_png icon_4" }, [_vm._v("icon_4")]),
            _c("li", { staticClass: "icons_png icon_5" }, [_vm._v("icon_5")]),
            _c("li", { staticClass: "icons_png icon_6" }, [_vm._v("icon_6")]),
            _c("li", { staticClass: "icons_png icon_7" }, [_vm._v("icon_7")]),
            _c("li", { staticClass: "icons_png icon_8" }, [_vm._v("icon_8")]),
            _c("li", { staticClass: "icons_png icon_9" }, [_vm._v("icon_9")]),
            _c("li", { staticClass: "icons_png icon_10" }, [_vm._v("icon_10")]),
            _c("li", { staticClass: "icons_png icon_11" }, [_vm._v("icon_11")]),
            _c("li", { staticClass: "icons_png icon_12" }, [_vm._v("icon_12")]),
            _c("li", { staticClass: "icons_png icon_13" }, [_vm._v("icon_13")]),
            _c("li", { staticClass: "icons_png icon_14" }, [_vm._v("icon_14")]),
            _c("li", { staticClass: "icons_png icon_15" }, [_vm._v("icon_15")]),
            _c("li", { staticClass: "icons_png icon_16" }, [_vm._v("icon_16")]),
            _c("li", { staticClass: "icons_png icon_17" }, [_vm._v("icon_17")]),
            _c("li", { staticClass: "icons_png icon_18" }, [_vm._v("icon_18")]),
            _c("li", { staticClass: "icons_png icon_19" }, [_vm._v("icon_19")]),
            _c("li", { staticClass: "icons_png icon_20" }, [_vm._v("icon_20")]),
            _c("li", { staticClass: "icons_png icon_21" }, [_vm._v("icon_21")]),
            _c("li", { staticClass: "icons_png icon_22" }, [_vm._v("icon_22")]),
            _c("li", { staticClass: "icons_png icon_23" }, [_vm._v("icon_23")])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f017e266", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f017e266","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/ui.vue
// module id = kxq4
// module chunks = 34